import { gql } from '@apollo/client'

export const Query = gql`
  query ProductSpecifications(
    $companyId: ID!,
    $filters: ProductSpecificationFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    productSpecifications(
      companyId: $companyId,
      filters: $filters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        specification {
          id
          name
        }
        value
        product {
          ... on AssetType {
            id
            name
          }
          ... on Package {
            id
            name
          }
          ... on RowItem {
            id
            name
          }
          ... on Vehicle {
            id
            name
          }
        }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
